export default __webpack_public_path__ + "static/media/Mapping volcano.d1ffbaaa.jpg";